import React, { useEffect, useState } from 'react';
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UploadOutlined,
    UserOutlined,
    SmileOutlined,
    VideoCameraOutlined,
    MoonOutlined,
    SunOutlined,
    HomeOutlined,
    NotificationOutlined,
    AppstoreOutlined, 
    MailOutlined, 
    SettingOutlined, 
    BellOutlined, 
    HeartOutlined,
    MessageOutlined,
    CalendarOutlined,
    FileWordOutlined,
    CoffeeOutlined,
    CloseOutlined
} from '@ant-design/icons';
import { Layout, Menu, Button, theme, Space, Badge, Avatar, Dropdown, Breadcrumb, Flex, Drawer, Form, Input, Select, Switch } from 'antd';
import Logo from '../assets/image/logo/Octaplex Logo.png'
import { SIZES } from '../theme/constant';
import { useSelector, useDispatch } from 'react-redux';
import { loginCompany, logout } from '../redux/slices/authSlice';
import { Outlet, useNavigate } from 'react-router-dom';
import { decodeToken } from 'react-jwt';
import AuthRestAPI from '../restAPI/AuthRestAPI';


const { Header, Sider, Content } = Layout;

function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}
const items2 = [
    getItem('Home', '/Home', <HomeOutlined />),
    {
        type: 'divider',
    },
    getItem('Master Data', '/MasterData', <AppstoreOutlined />,[
        getItem('Branch', '/Branch'),
        getItem('Department', '/Department'),
        getItem('Role', '/Role'),
        getItem('User', '/User'),
        getItem('Committee Type', '/Committee-config'),
    ]),
    {
        type: 'divider',
    },
    getItem('Meeting Config', '/Meeting-Management', <VideoCameraOutlined />,[
        getItem('Manage Committee', '/Manage-committee'),
        getItem('Meetings', '/Meetings'),
        getItem('Alternative Signatory', '/Alt-signatory'),
        // getItem('Enhance Document', '/User'),
    ]),
    {
        type: 'divider',
    },
    getItem('Workflow', '/Workflow', <FileWordOutlined />,[
        getItem('Workflow', '/Workflow'),
    ]),
    {
        type: 'divider',
    },    
    getItem('Leave Management', '/Leave-Management', <CoffeeOutlined />,[
        getItem('Leave Management', '/Leave-Management'),
    ]),
    {
        type: 'divider',
    },
    getItem('Calendar', '/My-calendar', <CalendarOutlined />),
    {
        type: 'divider',
    },
    getItem('Chat', '/chat', <MessageOutlined />),
    {
        type: 'divider',
    },
    getItem('Settings', '/Settings', <SettingOutlined />),
];

const MainLayoutAlt = ({toggleTheme, getTheme}) => {
    const navigate = useNavigate();
    const [navSelected, setNavSelected] = useState("")
    const [companyList, setCompanyList] = useState([]);
    const [committeeCompanyId, setCommitteeCompanyId] = useState(null)

    const dispatch = useDispatch();    
    const { companyId, userCompany, token } = useSelector(state => state.auth);
    const [items, setItems] = useState([
        {
            key: '1',
            label: (
                <a href="#">
                  Hi there 
                </a>
            ),
            icon: <SmileOutlined />,
    
        },
        {
            key: '2',
            label: (
                <div >
                    <span style={{ marginRight: SIZES.medium }}>
                        Notification
                    </span>
                    <Badge count={5} />
                </div>
            ),
            icon: <NotificationOutlined />,
        },
        {
            key: '3',
            label: <div> <span style={{ marginRight: SIZES.medium }}>Mode</span>
                <Space direction="vertical" >
                    <Switch
                        unCheckedChildren={<SunOutlined />}
                        checkedChildren={<MoonOutlined />}
                        checked={!(getTheme === "default")}
                    />
                </Space>
            </div>,
        },
        {
            key: '4',
            danger: true,
            label: 'Logout',
        },
    ])

    useEffect(() => {
        if (window.location.href.includes("/Meeting-Management/alt-reallocation?token=")) {
            const parts = window.location.href.split("?token=");
            const decodedTokenValues = decodeToken(parts[1]);
            setCommitteeCompanyId(decodedTokenValues?.committeeCompanyId ? decodedTokenValues.committeeCompanyId : null)
        }
    },[])

    useEffect(()=>{
        setItems(prevItems => 
            prevItems.map(item => 
                item.key === '3' ? { 
                    ...item, label: 
                    <div> 
                        <span style={{ marginRight: SIZES.medium }}>Mode</span>
                        <Space direction="vertical" >
                            <Switch
                                unCheckedChildren={<SunOutlined />}
                                checkedChildren={<MoonOutlined />}
                                checked={!(getTheme === "default")}
                            />
                        </Space>
                    </div>
              } : item
            )
        );
    },[getTheme]);

    useEffect(()=>{
        const formattedCompanyData = userCompany?.companyData && userCompany?.companyData.map(company => ({
            value: company?.companyId,
            label: <Badge color={`${company?.themeColor || 'yellow'}`} text={`${company?.companyName}`}  />,
            disabled: !company.status
        }));

        setCompanyList(formattedCompanyData)

    },[userCompany]);

    useEffect(()=>{
        const companyInfo = userCompany.companyData.find(company => company.companyId === companyId);
        setItems(prevItems => 
            prevItems.map(item => 
                item.key === '1' ? { 
                    ...item, label: 
                    <a href="#">
                        {companyInfo.name}  
                    </a> 
              } : item
            )
        );
    },[companyId])
    

    const {
        token: {
            colorBgContainer,
            borderRadiusLG,
            colorBgBase },
        colorPrimary,
    } = theme.useToken();

    const onClick = async ({key}) => {

        switch(key) {
            case "3" : toggleTheme();
                break;
            case "4" : 
                try {
                    await AuthRestAPI.logout(companyId, token);
                } catch (_) {
                    // Ignore logout API errors and continue local logout.
                }
                dispatch(logout());
                navigate('/login')
                break;
            default :
                break;
        }
    }

    const handleChangeCompanySelect = (value) => {
        const selectedCompany = userCompany.companyData.find(company => company.companyId === value);
        const roles = selectedCompany?.roles || [];
        const payload = {
            companyId : value,
            role : roles,
            userDetailsId: selectedCompany?.userDetailsId,
        }
        dispatch(loginCompany(payload))
    }

    const menuHandler = (value) => {
        setNavSelected(value?.keyPath[0] || "");
        navigate(`/${value?.keyPath[1] || ''}${value?.keyPath[0] || '/'}`)
    }

    
    return (

        <Layout style={{ height: "100svh", overflowY: "auto" }}>
            {/* <Sider trigger={null} collapsible collapsed={true}> */}
                {/* <Menu
                    mode="inline"
                    defaultSelectedKeys={[navSelected]}
                    items={items2}
                    style={{
                        height: '100vh',
                        padding: "0 10px",
                        overflowY: "auto",
                        alignContent:'center'
                    }}
                    onClick={menuHandler}
                /> */}

            {/* </Sider> */}
            {/* Bug 9801 */}
            <Flex vertical={"horizontal"} style={{ width: "calc(100svw - 0px)" }}> 
                <Header
                    style={{
                        paddingLeft: 0,
                        paddingRight: 16,
                        background: colorBgBase,
                        display: 'flex',
                    }}
                >
                    <Flex justify='space-between' align='center' style={{ width: '100%' }}>
                        <div>
                            <Flex align='center'>
                                <img src={Logo} height="28px" alt='' style={{ marginLeft: SIZES.xLarge }} />
                                <Select
                                    size='large'
                                    style={{
                                        width: 180,
                                        marginLeft: SIZES.xLarge,
                                        marginRight: SIZES.xLarge
                                    }}
                                    options={companyList}
                                    onChange={handleChangeCompanySelect}
                                    // value={companyId}
                                    value={committeeCompanyId}
                                    variant="filled"
                                    disabled
                                />
                            </Flex>
                        </div>
                        <div>
                        {/* <Button type='primary' icon={<CloseOutlined />} href="https://www.google.com" /> */}
                        </div>
                    </Flex>
                </Header>
                <Content style={{ height: "calc(100svh - 64px)", overflowY: "auto" }}>
                    <Outlet />
                </Content>
            </Flex>
        </Layout>
    );
};
export default MainLayoutAlt;